import styled from 'styled-components'
import { VARIABLES } from '../../themes'
import { ICONS } from '../../themes'

// Wrapper
// ============================================================
export const SupplierDiscoveryInformationStyle = styled.div`
  /* Parent styles
  ------------------------------- */
  width: 100%;

  /* Child element styles
  ------------------------------- */
  .attached-file-list {
    a {
      &.file-link {
        max-width: 330px;
      }
    }
  }
  iframe {
    pointer-events: none;
    overflow: hidden;
    overflow-x: hidden;
    overflow-y: hidden;
    height: 100%;
    width: 100%;
  }

  .is-ellipsis {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .style-table {
    max-height: 85vh;
    width: 100%;
    overflow: hidden auto;
    padding: 10px;
    margin: 20px 0 20px 0;
  }
  .footerTabSustain {
    margin-top: 20px;
    width: 100%;
    background-color: #f7f7f7;
    display: flex;
    justify-content: center;
    .btn-footer {
      font-weight: normal;
      width: 300px;
      border: 1px solid #4b4acb;
      color: #4b4acb;
      background-color: #e3ebf0;
      margin: 15px 10px;
    }
  }

  /* Start Scoreboard  */
  .scoreboard-wrapper {
    max-width: 380px;
    width: 100%;
  }

  .scoreboard {
    display: flex;
    min-width: 250px;
    max-width: 380px;
    flex-direction: column;
    padding: 24px;
    background: ${VARIABLES.COLORS.GRAY_7};
    box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.25);
    border-radius: 6px;

    hr {
      margin-bottom: 16px;
      color: ${VARIABLES.COLORS.GRAY_2};
    }
  }

  .risk-level {
    display: flex;
    align-items: center;
    padding: 7px 8px;
    margin-bottom: 16px;
    border-radius: 4px;
    background-color: ${VARIABLES.COLORS.GRAY_17};

    .caption {
      font-size: ${VARIABLES.TYPOGRAPHYS.FONT_SIZES_PX.SM};
      font-weight: ${VARIABLES.TYPOGRAPHYS.FONT_WEIGHT.FIRST_SEMI_BOLD};
      color: ${VARIABLES.COLORS.BLUE_1};
      line-height: 1;
      flex: none;
      padding-right: 8px;
    }

    .box-status {
      display: flex;
      flex-grow: 1;
      gap: 2px;
    }

    .status {
      border-radius: 2px;
      font-size: ${VARIABLES.TYPOGRAPHYS.FONT_SIZES_PX.TN};
      color: ${VARIABLES.COLORS.WHITE};
      display: flex;
      flex: 1;
      justify-content: center;
      align-items: center;
      max-height: 18px;

      &.green {
        background-color: ${VARIABLES.COLORS.GREEN_1};
      }

      &.light-green {
        background-color: ${VARIABLES.COLORS.GREEN_8};
      }

      &.light-orange {
        background-color: ${VARIABLES.COLORS.YELLOW_1};
      }

      &.orange {
        background-color: ${VARIABLES.COLORS.ORANGE_2};
      }

      &.red {
        background-color: ${VARIABLES.COLORS.RED_3};
      }
    }
  }

  .risk-board-row {
    display: flex;
    margin-bottom: 16px;

    .risk-box + .risk-box {
      margin-left: 16px;
    }
  }

  .risk-board {
    display: flex;
    gap: 16px;
    flex-wrap: wrap;
    margin-bottom: 16px;
  }

  .comprehensive-wrapper {
    display: flex;

    .comprehensive-label {
      display: flex;
      flex: none;
      font-size: 14px;
      font-weight: 600;
      color: ${VARIABLES.COLORS.BLUE_1};
      text-align: right;
      padding-right: 8px;
    }

    .comprehensive-status {
      display: flex;
      flex-grow: 1;
      gap: 8px;
      align-items: center;
      justify-content: center;
    }

    .status {
      font-size: 0.75em;
      line-height: 1.1;
      border-radius: 5px;
      display: flex;
      flex: 1;
      padding: 8px;
      justify-content: center;

      &.gray {
        border: 2px solid #aaaaaa;
        color: #aaaaaa;
      }

      &.orange {
        color: #fc8601;
        border: 2px solid #fc8601;
      }

      &.green {
        color: #16a651;
        border: 2px solid #16a651;
      }

      .label {
        display: flex;
        flex: none;
      }
    }
  }
  /* End Scoreboard  */

  .data-contact-person {
    margin-top: -10px;

    .is-ellipsis {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .table-borderless {
      .table-column {
        padding-left: 0;
      }
    }
  }

  .main-content {
    position: relative;
    padding: 67px 60px 20px 60px;
    //min-width: 1450px;
    margin-bottom: 20px;

    .content-body {
      flex-wrap: nowrap;
      align-content: flex-start;
      align-items: flex-start;
    }

    .supplier-information {
      & > .react-tabs__tab-panel {
        /* height: 770px; */
        position: relative;
      }
    }

    &:last-child {
      margin-bottom: 0;
      padding: 67px 60px;
    }
  }

  &.detail-list {
  }

  .highlight {
    background-color: ${VARIABLES.COLORS.GRAY_4};
    color: ${VARIABLES.COLORS.BLUE_1};
  }

  .lists-wrapper {
    overflow-y: scroll;
    flex-wrap: wrap;
    width: calc(100% + 13px);
    margin-right: -13px;
    min-height: 770px;
    max-height: 770px;
    padding-right: 5px;
    align-items: flex-start;
    align-content: flex-start;

    .label {
      font-weight: ${VARIABLES.TYPOGRAPHYS.FONT_WEIGHT.FIRST_MEDIUM};
    }

    .lists {
      /* width: 100%; */
      height: 500px;
      margin-bottom: 10px;
      border: 1px solid ${VARIABLES.COLORS.GRAY_2};
      border-radius: ${VARIABLES.BORDER_RADIUSES.XS};
      padding: 15px 30px;
      display: flex;
      /* width: 100%; */
      flex-wrap: wrap;
      align-content: flex-start;

      &:last-child {
        margin-bottom: 0;
      }
    }

    .list {
      margin-bottom: 10px;
      display: flex;
      width: 100%;
      color: ${VARIABLES.COLORS.BLUE_1};
      word-break: break-word;
      align-items: flex-start;
      line-height: 1.55;

      .data {
        line-height: 1.55;
        height: auto;

        span {
          &.Red {
            color: ${VARIABLES.COLORS.RED_3};
          }

          &.Orange {
            color: ${VARIABLES.COLORS.YELLOW_1};
          }

          &.Green {
            color: ${VARIABLES.COLORS.GREEN_7};
          }
        }

        .readmore {
          display: none;
          padding: 0;
          height: 0;
          z-index: ${VARIABLES.Z_INDEXS.NEGATIVE_2};
        }
      }

      &.description-row {
        .data {
          &.is-ellipsis {
            height: 3rem;
            overflow-y: hidden;
            position: relative;

            .readmore {
              font-weight: ${VARIABLES.TYPOGRAPHYS.FONT_WEIGHT.FIRST_MEDIUM};

              content: '...Readmore';
              display: inline-block;
              position: absolute;
              background-color: white;
              bottom: 0;
              right: 0;
              height: calc(17px * 1.55);
              z-index: ${VARIABLES.Z_INDEXS.LV_1};
              color: ${VARIABLES.COLORS.BLUE_9};
            }
          }
        }
      }

      &:last-child {
        margin-bottom: 0;
      }
    }

    .score-row,
    .category-row {
      .label {
        display: flex;
        align-items: center;
      }

      span {
        margin-left: 5px;
        display: flex;
      }
    }

    /* width */
    ::-webkit-scrollbar {
      width: 8px;
      margin-right: -13px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
      background: ${VARIABLES.COLORS.GRAY_2};
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
      background: ${VARIABLES.COLORS.BLUE_4};
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
      background: ${VARIABLES.COLORS.BLUE_1};
    }
  }

  /* Modifiers
  ------------------------------- */

  /* &.offline-comprehensive-assessment {
    .header-wrapper {
      justify-content: space-between;
      margin-right: 10px;
    }

    .template-total-score {
      justify-content: end;
    }

    .toggle-icon {
      padding-right: 15px;
    }
  } */

  .label-gray {
    color: #aaaaaa;
  }

  .updated {
    justify-content: center;
    .last-update {
      width: auto;
    }
  }

  .sustainability {
    .lists {
      flex: 0 0 330px;
    }

    .label {
      flex: 0 0 110px;
    }
  }

  .offline-comprehensive {
    .lists {
      flex: 0 0 40%;
      max-width: 430px;
    }

    .label {
      flex: 0 0 50%;
      max-width: 160px;
    }
  }

  .grade {
    font-weight: 700;

    &.green {
      color: #16a651;
    }

    &.green-light {
      color: #8ad000;
    }

    &.yellow {
      color: #f5ab02;
    }

    &.red {
      color: #ce1f0f;
    }
  }

  /* tooltip  */
  .background-white {
    background-color: white;
    opacity: 1 !important;
    box-shadow: 0px 1px 2px 1px rgba(0, 0, 0, 0.12) !important;
    border: 0 !important;
    color: ${VARIABLES.COLORS.GRAY_3};
    white-space: pre-line;
    font-size: ${VARIABLES.TYPOGRAPHYS.FONT_SIZES_PX.MD};

    &.place-bottom {
      border-bottom-color: white;

      &:after,
      &before {
        display: none;
      }
    }
  }

  /* Media queries
  ------------------------------- */
  @media all and (max-width: 1700.98px) {
    .main-content {
      padding: 55px 25px;

      &:last-child {
        padding: 55px 25px;
      }
    }
  }

  @media all and (max-width: 1600.98px) {
    .main-content {
      padding: 40px 25px;

      &:last-child {
        padding: 40px 25px;
      }
    }

    /* .lists-wrapper {
      min-height: 600px;
      max-height: 600px;

      .lists {
        .list {
          .label {
            flex: 0 0 100px;
          }

          &.description-row {
            .data {
              &.is-ellipsis {
                height: 2.9rem;

                .readmore {
                  height: calc(14.5px * 1.55);
                }
              }
            }
          }
        }
      }
    } */
  }

  @media all and (max-width: 1440.98px) {
    .main-content {
      padding: 30px 20px;

      &:last-child {
        padding: 30px 25px;
      }
    }

    /* .lists-wrapper {
      min-height: 500px;
      max-height: 500px;

      .lists {
        border-radius: 5px;
        padding: 15px 20px;

        .list {
          .label {
            flex: 0 0 100px;
          }

          &.description-row {
            .data {
              &.is-ellipsis {
                height: 2.85rem;

                .readmore {
                  height: calc(14.5px * 1.55);
                }
              }
            }
          }
        }
      }
    } */
  }

  @media all and (max-width: 1366.98px) {
    .main-content {
      padding: 20px 15px;

      &:last-child {
        padding: 20px 15px;
      }
    }

    /* .lists-wrapper {
      min-height: 450px;
      max-height: 450px;

      .lists {
        padding: 10px 20px;

        .list {
          margin-bottom: 5px;

          .label {
            flex: 0 0 90px;
          }

          &.description-row {
            .data {
              &.is-ellipsis {
                height: 2.7rem;

                .readmore {
                  height: calc(14.5px * 1.55);
                }
              }
            }
          }
        }
      }
    } */
  }

  /* Start max-width: '1439px'*/
  @media all and (max-width: ${VARIABLES.BREAKPOINTS.DESKTOP_SM_MAX}) {
    .scoreboard-wrapper {
      max-width: 250px;
    }

    .scoreboard {
      padding: 10px;
    }

    .risk-level {
      padding: 5px;

      .caption {
        font-size: ${VARIABLES.TYPOGRAPHYS.FONT_SIZES_PX.MN};
        padding-right: 5px;
      }

      .status {
        font-size: ${VARIABLES.TYPOGRAPHYS.FONT_SIZES_PX.MN};
      }
    }

    .comprehensive-wrapper {
      .comprehensive-label {
        font-size: 10px;
        line-height: 1.2;
        padding-right: 5px;
        gap: 5px;
      }

      .status {
        padding: 5px;
        font-size: 8px;
      }
    }
  }

  @media all and (max-width: 1280.98px) {
    .lists {
      width: 250px !important;
      height: 350px !important;
    }
    .chart {
      width: 450px !important;
    }
    .footer {
      .full-score {
        margin-right: 8px !important;
      }
      .high-risk {
        margin: 0 8px 0 8px !important;
        .box-red {
          margin: auto 4px auto 0 !important;
          width: 10px !important;
          height: 10px !important;
        }
      }
      .medium-risk {
        margin: 0 8px 0 8px !important;
        .box-yellow {
          margin: auto 4px auto 0 !important;
          width: 10px !important;
          height: 10px !important;
        }
      }
      .low-risk {
        margin: 0 8px 0 8px !important;
        .box-green {
          margin: auto 4px auto 0 !important;
          width: 10px !important;
          height: 10px !important;
        }
      }
    }
    .main-content {
      padding: 15px;

      &:last-child {
        padding: 15px;
      }
    }

    /* .lists-wrapper {
      min-height: 400px;
      max-height: 400px;

      .lists {
        padding: 15px;

        .list {
          .label {
            flex: 0 0 85px;
          }

          &.description-row {
            .data {
              &.is-ellipsis {
                height: 2.7rem;

                .readmore {
                  height: calc(14.5px * 1.55);
                }
              }
            }
          }
        }
      }
    } */
  }

  @media all and (max-width: 1024.98px) {
    .lists {
      width: 250px !important;
      height: 350px !important;
    }
    .chart {
      width: 400px !important;
    }
    .main-content {
      padding: 10px;

      &:last-child {
        padding: 10px;
      }
    }

    /* .lists-wrapper {
      min-height: 350px;
      max-height: 350px;

      .lists {
        padding: 10px;

        .list {
          margin-bottom: 2px;

          .label {
            flex: 0 0 80px;
          }

          &.description-row {
            .data {
              &.is-ellipsis {
                height: 2.4rem;

                .readmore {
                  height: calc(13px * 1.55);
                }
              }
            }
          }
        }
      }
    } */
  }
  @media all and (max-width: 960px) {
    .lists {
      width: 250px !important;
      height: 330px !important;
    }
    .chart {
      width: 350px !important;
    }
    .footer {
      .full-score {
        margin-right: 5px !important;
      }
      .high-risk {
        margin: 0 5px 0 5px !important;
        .box-red {
          margin: auto 4px auto 0 !important;
          width: 10px !important;
          height: 10px !important;
        }
      }
      .medium-risk {
        margin: 0 5px 0 5px !important;
        .box-yellow {
          margin: auto 4px auto 0 !important;
          width: 10px !important;
          height: 10px !important;
        }
      }
      .low-risk {
        margin: 0 5px 0 5px !important;
        .box-green {
          margin: auto 4px auto 0 !important;
          width: 10px !important;
          height: 10px !important;
        }
      }
    }
  }
  @media all and (max-width: 933px) {
    .lists {
      width: 200px !important;
      height: 300px !important;
    }
    .title {
    }
    .chart {
      width: 300px !important;
    }
    .footer {
      font-size: ${VARIABLES.TYPOGRAPHYS.FONT_SIZES_PX.MN} !important;
      .full-score {
        margin-right: 4px !important;
      }
      .high-risk {
        margin: 0 4px 0 4px !important;
        .box-red {
          margin: auto 2px auto 0 !important;
          width: 8px !important;
          height: 8px !important;
        }
      }
      .medium-risk {
        margin: 0 4px 0 4px !important;
        .box-yellow {
          margin: auto 2px auto 0 !important;
          width: 8px !important;
          height: 8px !important;
        }
      }
      .low-risk {
        margin: 0 4px 0 4px !important;
        .box-green {
          margin: auto 2px auto 0 !important;
          width: 8px !important;
          height: 8px !important;
        }
      }
    }
  }
`
